<template>
  <Card class="nch--home-post">
    <div
      class="nch-post-image"
      :style="imageStyle"
    ></div>
    <div class="nch--post-content">
      <div class="category" :style="{ backgroundColor: category.color }">
        <a
          :title="category.translation.name"
          :href="`/blog/category/${category.translation.slug}`"
        >{{ category.translation.name }}</a>
      </div>
      <div class="meta">
        <a
          class="post-title"
          :href="`/blog/post/${post.translation.slug}`"
          :title="post.translation.title"
        >{{ post.translation.title }}</a>
        <br>
        <span>{{ $moment(post.created_at).format('LL') }} &middot; {{ post.author.name }}</span>
      </div>
      <p
        class="nch--post-description"
        v-if="post.translation.meta_description"
        v-html="post.translation.meta_description"
      ></p>
      <div class="info">
        <i class="mdi mdi-eye"></i>
        <span>
          {{ post.views || 0 }}
        </span>
        <i class="mdi mdi-chat"></i>
        <span>
          {{ post.comments_count || 0 }}
        </span>
      </div>
    </div>
  </Card>
</template>
<script>
import Card from '../common/Card';
import Button from '../common/Button';
import responsive from '../../mixins/responsive';

export default {
  name: 'HomePost',
  components: {
    Card,
    Button,
  },
  mixins: [
    responsive,
  ],
  props: {
    value: {
      type: Object,
      required: true,
      description: 'Post object',
    },
  },
  computed: {
    post() {
      return this.value;
    },
    category() {
      return this.post.category;
    },
    imageStyle() {
      const style = { backgroundColor: this.category.color };
      if (this.post.thumbUrl) {
        style.backgroundImage = `url('${this.post.thumbUrl}')`;
      }
      return style;
    },
  },
};
</script>

<style scoped>
.nch--home-post{
  display: flex;
  flex-direction: column;
  justify-content: space-between !important;
  width: 100%;
  height: 100%;
  padding: 0 !important;
  margin: 0 !important;
}
.nch--post-content{
  position: relative;
  display: flex;
  flex-direction: column;
  align-content: flex-start;
  justify-content: space-between;
  flex-grow: 1;
  padding: 1rem;
}
.nch--post-description {
  position: relative;
  margin-bottom: .5rem;
  max-height: 60px;
  flex-grow: 1;
  overflow: hidden;
}
.nch--post-description::after{
  content: "";
  background: linear-gradient(90deg,rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%);
  display: block;
  position: absolute;
  pointer-events: none;
  bottom: 0;
  width: 100%;
  height: 45%;
  z-index: 15;
}
.nch-post-image{
  width: 100%;
  height: 180px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
.post-title{
  font-size: 1.4rem;
  line-height: 1;
  word-break: break-word;
  color: var(--blog-text);
  font-weight: 600;
}
.post-title:hover{
  cursor: pointer;
  color: var(--blog-link);
}
.info span{
  margin-right: 5px;
}
.meta{
  margin: .5rem 0;
}
.meta span{
  font-size: .7rem;
}

.nch--post-content .category {
  position: absolute;
  right: 0;
  top: -0.3rem;
  font-size: .9rem;
  padding: .1rem .3rem;
  background-color: rgba(0,0,0,0.3);
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  max-width: 90%;
  overflow: hidden;
  white-space: nowrap;
  color: #fff;
  text-overflow: ellipsis;
}
.nch--post-content .category a,
.nch--post-content .category a:hover {
  color: #fff;
}
</style>

<style>
.nch--post-description p {
  padding: 0;
  margin-bottom: 0;
  line-height: 1.2;
}
</style>
